import { postRequest, fetchTransactionStatus } from '@/api';
import {
  NETS_PAYMENT_MUTATIONS,
  PAYTRAIL_PAYMENT_MUTATIONS,
  REFILL_VOUCHER_MUTATIONS,
} from '@/store/mutation-types';
export const state = () => {
  return {
    paymentPending: false,
    waitingForRedirect: false,
    paymentError: null,
    redirectUrl: null,
    paytrailForm: [],
    paytrailTerminal: '',

    voucher: null,
    voucherError: null,
    voucherPending: false,
  };
};

export const actions = {
  async paytrailForm({ commit, rootGetters }, data) {
    const cart = rootGetters['cart/cart'];
    const packetId = cart.packet ? parseInt(cart.packet.id) : null;
    const saldo = cart.saldo;
    const payload = { ...data, saldo, packetId };
    const success = await postRequest(
      '/payments/paytrail_pay',
      payload,
      PAYTRAIL_PAYMENT_MUTATIONS,
      commit
    );
    return success;
  },

  async netsPay({ commit, rootGetters, state }, data) {
    const cart = rootGetters['cart/cart'];
    const packetId = cart.packet ? parseInt(cart.packet.id) : null;
    const saldo = cart.saldo;
    const lang = window.localStorage.getItem('locale');
    const payload = { ...data, saldo, packetId };
    if (lang) {
      payload['lang'] = lang;
    }
    const success = await postRequest(
      '/payments/nets_pay',
      payload,
      NETS_PAYMENT_MUTATIONS,
      commit
    );
    if (success) {
      commit('cart/clearSaldo', null, { root: true });
      commit('cart/clearPacket', null, { root: true });
      window.location.href = state.redirectUrl;
    }
  },

  async voucher({ commit }, data) {
    return await postRequest(
      '/payments/voucher',
      data,
      REFILL_VOUCHER_MUTATIONS,
      commit
    );
  },

  clearVoucherData({ commit }) {
    commit('clearVoucherData');
  },

  fetchTransaction(_ctx, { orderId }) {
    return fetchTransactionStatus(orderId);
  },
};

export const mutations = {
  // Nets
  [NETS_PAYMENT_MUTATIONS.SUCCESS]: (state, data) => {
    state.redirectUrl = data.terminalUrl;
    state.waitingForRedirect = true;
  },
  [NETS_PAYMENT_MUTATIONS.PENDING]: (state, pending) =>
    (state.paymentPending = pending),
  [NETS_PAYMENT_MUTATIONS.FAILURE]: (state, error) =>
    (state.paymentError = error),

  // Paytrail
  [PAYTRAIL_PAYMENT_MUTATIONS.SUCCESS]: (state, data) => {
    state.paytrailForm = data.form;
    state.paytrailTerminal = data.terminalUrl;
    state.waitingForRedirect = true;
  },
  [PAYTRAIL_PAYMENT_MUTATIONS.PENDING]: (state, pending) =>
    (state.paymentPending = pending),
  [PAYTRAIL_PAYMENT_MUTATIONS.FAILURE]: (state, error) =>
    (state.paymentError = error),

  [REFILL_VOUCHER_MUTATIONS.SUCCESS]: (state, voucher) =>
    (state.voucher = voucher),
  [REFILL_VOUCHER_MUTATIONS.PENDING]: (state, pending) =>
    (state.voucherPending = pending),
  [REFILL_VOUCHER_MUTATIONS.FAILURE]: (state, error) =>
    (state.voucherError = error),

  clearVoucherData: state => {
    state.voucher = null;
    state.voucherError = null;
  },
};

export const getters = {
  loading: state => state.paymentPending,
  error: state => state.paymentError,
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
